<dx-popup title="Zip Code" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="zip">
        <dxi-form-item dataField="color"> </dxi-form-item>
        <dxi-form-item dataField="zoneNumber"
            ><div *dxTemplate>
                <dx-select-box [(value)]="zip.zoneNumber" [items]="zones"></dx-select-box></div
        ></dxi-form-item>
        <dxi-form-item dataField="territory"> </dxi-form-item>
        <dxi-form-item dataField="primaryCity" [editorOptions]="{ readOnly: true }"> </dxi-form-item>
        <dxi-form-item dataField="county" [editorOptions]="{ readOnly: true }"> </dxi-form-item>
        <dxi-form-item dataField="zipCode" [editorOptions]="{ readOnly: true }"> </dxi-form-item>
    </dx-form>
</dx-popup>
